import { Typography } from "@mui/material";
import { COLOR_DANGER } from "../../commons/LaColors";

const InlineErrorMessage = (props: { errorMessage: string[] }) => {
  return (
    <>
      {props.errorMessage.map((item, index) => {
        return (
          <Typography
            key={index}
            align="left"
            component="h1"
            variant="body1"
            color={COLOR_DANGER}
          >
            {item}
          </Typography>
        );
      })}
    </>
  );
};

export default InlineErrorMessage;
